import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import logo from "../../assets/ooklass-blue-removebg.png";
import QR from "../../assets/ooklass-QR.png"
import { formatDate } from "../../utils";

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    lineHeight: 1.5,
  },

  border:{
    border: "2px #fe8366 solid",
    margin: 10,
    padding: 40
  },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  logo: {
    width: 150,
    height: 70,
  },
  dateContainer: {
    textAlign: "right",
    
  },
  dateLabel: {
    fontSize: 10,
    color: "#555",
  },
  dateValue: {
    fontSize: 12,
    fontWeight: "bold",
  },
 
  receiverContainer: {
    textAlign: "right",
    marginTop: 10,
  },
  receiverLabel: {
    fontSize: 12,
    color: "#555"
  },
  receiverValue: {
    fontSize: 14,
    fontWeight: "bold",
  },
  horizontalLine: {
    borderBottom: 1,
    marginBottom: 10,
  },
  studentInfoContainer: {
    marginTop: 20,
    marginBottom: 20,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  studentInfoLeft: {
    fontSize: 14
  },
  studentInfoRight: {
    width: "45%",
    textAlign: "right",
  },
  tableContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  tableCell: {
    width: "48%",
    textAlign: "center",
    color:"#555"
  },
  tableCell1: {
    width: "48%",
    textAlign: "center",
  },
  coachingContainer: {
    marginTop: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  coachingInfo: {
    width: "80%",
    fontSize: 10,
  },
  logoQR: {
    width: 100,
    height: 100,
  },
  signatureContainer: {
    textAlign: "left",
    marginTop: 20,
  },
  signatureLabel: {
    fontSize: 10,
  },
  signatureLine: {
    borderBottom: 1,
    marginTop: 30,
    marginBottom: 5,
  },
});

const InvoicePDF = ({ studentData, feesData }) => {

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.border}>
          <View style={styles.header}>
            <Image src={logo} style={styles.logo} />
          </View>
          
            <View style={styles.dateContainer}>
              <Text style={styles.dateLabel}>Date of Invoice</Text>
              <Text style={styles.dateValue}>{formatDate(new Date())}</Text>
            </View>
            {/* <Text style={styles.invoiceNoLabel}>Invoice No.</Text>
            <Text style={styles.invoiceNoValue}></Text> */}
         
          <View style={styles.receiverContainer}>
            <Text style={styles.receiverLabel}>Receiver Details:</Text>
            <Text style={styles.receiverValue}>OOklass Tuition Classes</Text>
            <Text style={styles.receiverValue}>+91-6377132574</Text>
            <Text style={styles.receiverValue}>+91-7665873094</Text>
            <Text style={styles.receiverValue}>
              Ward No.27 , Near water works
            </Text>
            <Text style={styles.receiverValue}>Lalgarh Jattan</Text>
          </View>
          <View style={styles.horizontalLine} />
          <View style={styles.studentInfoContainer}>
            <View style={styles.studentInfoLeft}>
              <Text>Student Name: {studentData.name}</Text>
              <Text>Father Name: {studentData.fathername}</Text>
              <Text>Class: {studentData.class}</Text>
              {/* <Text>DOB: {formatDate(new Date(studentData.dob))}</Text> */}
              <Text>Contact: {studentData.contact}</Text>
            </View>
          </View>
          <View style={styles.horizontalLine} />
          <View style={styles.tableContainer}>
          <Text style={styles.tableCell}>Payment Date</Text>
            <Text style={styles.tableCell}>Amount Paid</Text>
            <Text style={styles.tableCell}>Next Due Date</Text>
          </View>
          <View key={feesData.id} style={styles.tableContainer}>
          <Text style={styles.tableCell1}>{formatDate(new Date(feesData.date))}</Text>
            <Text style={styles.tableCell1}>{feesData.amoutPaid}/-</Text>
            <Text style={styles.tableCell1}>{formatDate(new Date(feesData.nextDue))}</Text>
          </View>
          <View style={styles.horizontalLine} />
          <View style={styles.coachingContainer}>
            <View style={styles.coachingInfo}>
              <Text>Coaching Details:</Text>
              <Text>Website: www.ooklass.in</Text>
              <Text>Instagram: @ooklass.in</Text>
              <Text>Email: admin@ooklass.in</Text>
              {/* Add other coaching details here */}
            </View>
            <Image src={QR} style={styles.logoQR} />
          </View>
          <View style={styles.signatureContainer}>
            <Text style={styles.signatureLabel}>Signature:</Text>
            <View style={styles.signatureLine} />
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default InvoicePDF;
